<div aria-live="polite" class="validation" role="status">
    <p [ngClass]="{'invalid' :  oneNumber == false || oneLower == false|| oneUpper == false|| minLength == false|| whiteSpace || oneSpecial == false}">
        Password Requirements:</p>
    <ul>
        <li [ngClass]="{'invalid' : minLength == false}">
            <mat-icon aria-hidden="true" class="reqIcon">{{ minLength ? 'check' : 'close' }}</mat-icon>
            Must be at least {{ length }} characters long.
            <span class="cdk-visually-hidden">{{ minLength ? '(met)' : '(not met)' }}</span>
        </li>
        <li [ngClass]="{'invalid' : oneNumber == false }">
            <mat-icon aria-hidden="true" class="reqIcon">{{ oneNumber ? 'check' : 'close' }}</mat-icon>
            Must contain at least 1 number.
            <span class="cdk-visually-hidden">{{ oneNumber ? '(met)' : '(not met)' }}</span>
        </li>
        <li [ngClass]="{'invalid' : oneLower == false}">
            <mat-icon aria-hidden="true" class="reqIcon">{{ oneLower ? 'check' : 'close' }}</mat-icon>
            Must contain at least 1 lowercase character.
            <span class="cdk-visually-hidden">{{ oneLower ? '(met)' : '(not met)' }}</span>
        </li>
        <li [ngClass]="{'invalid' : oneUpper == false}">
            <mat-icon aria-hidden="true" class="reqIcon">{{ oneUpper ? 'check' : 'close' }}</mat-icon>
            Must contain at least 1 uppercase character.
            <span class="cdk-visually-hidden">{{ oneUpper ? '(met)' : '(not met)' }}</span>
        </li>
        <li [ngClass]="{'invalid' : oneSpecial == false}">
            <mat-icon aria-hidden="true" class="reqIcon">{{ oneSpecial ? 'check' : 'close' }}</mat-icon>
            Must contain at least 1 special character.
            <span class="cdk-visually-hidden">{{ oneSpecial ? '(met)' : '(not met)' }}</span>
        </li>
        <li [ngClass]="{'invalid' : whiteSpace}">
            <mat-icon aria-hidden="true" class="reqIcon">{{ !whiteSpace ? 'check' : 'close' }}</mat-icon>
            Password cannot contain whitespace
            <span class="cdk-visually-hidden">{{ !whiteSpace ? '(met)' : '(not met)' }}</span>
        </li>
        <li [ngClass]="{'invalid' : matching}">
            <mat-icon aria-hidden="true" class="reqIcon">{{ !matching ? 'check' : 'close' }}</mat-icon>
            Passwords must match
            <span class="cdk-visually-hidden">{{ !matching ? '(met)' : '(not met)' }}</span>
        </li>
    </ul>
</div>
